<template>
  <svg
    :width="size"
    :height="size"
    :class="['google-icon', `size-${size}`]"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1712 8.36791H17.5001V8.33325H10.0001V11.6666H14.7096C14.0225 13.607 12.1762 14.9999 10.0001 14.9999C7.23883 14.9999 5.00008 12.7612 5.00008 9.99992C5.00008 7.23867 7.23883 4.99992 10.0001 4.99992C11.2746 4.99992 12.4342 5.48075 13.3171 6.26617L15.6742 3.90909C14.1859 2.52192 12.195 1.66659 10.0001 1.66659C5.39758 1.66659 1.66675 5.39742 1.66675 9.99992C1.66675 14.6024 5.39758 18.3333 10.0001 18.3333C14.6026 18.3333 18.3334 14.6024 18.3334 9.99992C18.3334 9.44117 18.2759 8.89575 18.1712 8.36791Z"
      fill="#FFC107"
    />
    <path
      d="M2.62744 6.12117L5.36536 8.129C6.10619 6.29484 7.90036 4.99992 9.99994 4.99992C11.2744 4.99992 12.434 5.48075 13.3169 6.26617L15.674 3.90909C14.1857 2.52192 12.1948 1.66659 9.99994 1.66659C6.79911 1.66659 4.02328 3.47384 2.62744 6.12117Z"
      fill="#FF3D00"
    />
    <path
      d="M9.99994 18.3333C12.1524 18.3333 14.1082 17.5095 15.5866 16.17L13.0078 13.9875C12.1431 14.6451 11.0864 15.0008 9.99994 15C7.83286 15 5.99244 13.6179 5.29911 11.6891L2.58203 13.783C3.96036 16.4816 6.76119 18.3333 9.99994 18.3333Z"
      fill="#4CAF50"
    />
    <path
      d="M18.1713 8.36791H17.5001V8.33325H10.0001V11.6666H14.7096C14.3809 12.5902 13.7889 13.3972 13.0067 13.9879L13.0079 13.9871L15.5867 16.1696C15.4042 16.3354 18.3334 14.1666 18.3334 9.99992C18.3334 9.44117 18.2759 8.89575 18.1713 8.36791Z"
      fill="#1976D2"
    />
  </svg>
</template>

<script>
export default {
  name: "GoogleIcon",
  props: {
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style scoped lang="scss">
.google-icon {
  display: inline-block;
  flex-shrink: 0;
  /* No per-icon hover — matches WelcomeScreen.tsx (hover is only on the SSO button background) */

  &.size-16 {
    width: 16px;
    height: 16px;
  }

  &.size-20 {
    width: 20px;
    height: 20px;
  }

  &.size-24 {
    width: 24px;
    height: 24px;
  }
}
</style>
